// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"8e91fb91","383":"daeb9088","787":"142f51cf"}[chunkId] + ".chunk.js";
};